import { RouteObject } from 'react-router-dom';
import OnlineOrderDetailPage from '@app/page/online-order/detail/online-order-detail-page.tsx';
import { Layout } from '@app/Layout.tsx';
import ProductPickerPage from '@app/page/online-order/product-picker/product-picker-page.tsx';
import { OnlineOrderSuccessPage } from '@app/page/online-order/payment/success/online-order-success-page';
import { OnlineOrderCancelPage } from '@app/page/online-order/payment/cancel/online-order-cancel-page';

export const OnlineOrderRouter: RouteObject = {
  path: 'online-order',
  element: <Layout classNames={'bg-gray-100'} />,
  children: [
    {
      path: 'start',
      element: <ProductPickerPage />,
    },
    {
      path: ':onlineOrderID',
      element: <OnlineOrderDetailPage />,
    },
    {
      path: ':onlineOrderID/payment/success',
      element: <OnlineOrderSuccessPage />,
    },
    {
      path: ':onlineOrderID/payment/cancel',
      element: <OnlineOrderCancelPage />,
    },
  ],
};

// If this router were to have additional UI wrapper components, they would use these BEM classes:
// router-container, router-container__content
